import React from 'react';
import { ReactComponent as CalendarDotsFill } from '../icons/calendar-dots-fill.svg';
import { ReactComponent as PersonArmsSpreadFill } from '../icons/person-arms-spread-fill.svg';
import { ReactComponent as DogFill } from '../icons/dog-fill.svg';
import { ReactComponent as MapPinLineFill } from '../icons/map-pin-line-fill.svg';
import { ReactComponent as MinusBold } from '../icons/minus-bold.svg';
import { ReactComponent as PlusBold } from '../icons/plus-bold.svg';
import { ReactComponent as List } from '../icons/list.svg';

export const LocationIcon = () => <MapPinLineFill className="booking-bar__icon" />;

export const CalendarIcon = () => <CalendarDotsFill className="booking-bar__icon" />;

export const GuestsIcon = () => <PersonArmsSpreadFill className="booking-bar__icon" />;

export const PetsIcon = () => <DogFill className="booking-bar__icon" />;

export const MinusIcon = () => <MinusBold className="booking-bar__stepper-icon" />;

export const PlusIcon = () => <PlusBold className="booking-bar__stepper-icon" />;

// Placed after the label in the trigger, unlike every other field icon in the
// bar, which precede theirs.
export const MoreFiltersIcon = () => <List className="booking-bar__icon" />;
